import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { FaCheck } from 'react-icons/fa6';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdOutlineEdit } from 'react-icons/md';
import axios from 'axios'
import ResponseMsg2 from '../../general/ResponseMsg2';
import { AiOutlineEdit } from 'react-icons/ai';


const DormitoryRoom = ({setLoading}) => {
    const [response2, setResponse2] = useState({ message: '', status: 'success' });

    const [formData, setFormData] = useState({
        dormitory: '',
        room_no: '',
        room_type: '',
        no_of_bed: '',
        bed_cost: '',
        description: ''
    })

    const [searchFilter, setSearchFilter] = useState('');
    const [roomList, setRoomList] = useState([]);
    const [rooms, setRooms] = useState([]);

    const [editId, setEditId] = useState(null);
    const [dormitory, setDormitory] = useState([]);
      const [showDelete, setShowDelete]  = useState(false);
         const [selectedDoor,setSelectDoor]= useState('');


    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleAddNewRoomType = () => {
        const newRoomType = prompt('Enter new room type:');
        if (newRoomType && !roomList.includes(newRoomType)) {
            setRoomList((prev) => [...prev, newRoomType]);
            setFormData((prev) => ({
                ...prev,
                room_type: newRoomType
            }));
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

setLoading(true);

        if (editId) {
        try {
                
         const res = await axios.put(
        `https://api.kcian.in/update-hostel-room/${editId}`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      setResponse2({ message: 'Room Updated Successfully.', status: 'success' });  

      setEditId(null);
      fetchHostelRoom();
            } catch (error) {
               console.error("❌ Error:", error.response?.data || error.message);
            } finally {
                setLoading(false);
                        setTimeout(() => {
          setResponse2('');
        }, 3000);   
            }
        


        } else {

         
            try {
                const res = await axios.post(
                    "https://api.kcian.in/add-hostel-room",
                    formData,
                    { headers: { "Content-Type": "application/json" } }
                );
                console.log("✅ Success:", res.data);
                setResponse2({ message: 'Room Added to Dormitory.', status: 'success' });

fetchHostelRoom();
            } catch (err) {
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                setLoading(false);
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
            }

        }

        setFormData({
            dormitory: '',
            room_no: '',
            room_type: '',
            no_of_bed: '',
            bed_cost: '',
            description: ''
        })
    }


    const handleEdit = (itm) => {

        setFormData({
            dormitory: itm.dor_id,
            room_no: itm.room_no,
            room_type: itm.room_type,
            no_of_bed: itm.no_of_bed,
            bed_cost: itm.bed_cost,
            description: itm.description
        });
        setEditId(itm.id);
    }


        const fetchHostel = async () => {
            try {
                const res = await axios.get('https://api.kcian.in/fetch-dormitory');
                const dormitories = res.data;
                setDormitory(dormitories);
            } catch (error) {
                console.log(error);
            }
        };


    useEffect(() => {
        fetchHostel();
    }, []);



    const fetchHostelRoom = async () => {
setLoading(true);

try {
            const response = await axios.get('https://api.kcian.in/fetch-hostel-room');
const roomList = [...new Set(response.data.map(item => item.room_type))];
setRoomList(roomList);
                     setRooms(response.data);

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        fetchHostelRoom();
    }, []);


      const handleDelete = async (id) => {
        setLoading(true);
            try {
                const res = await axios.delete(`https://api.kcian.in/delete-hostel-room/${id}`);
              setResponse2({ message:  'Room Removed from Dormitory.', status: 'success' });
              setShowDelete(false);
              fetchHostelRoom();
            } catch (err) {
                console.error(err.response?.data || err.message);
            } finally {                
                        setLoading(false);
 setTimeout(() => {
          setResponse2('');
        }, 3000);   
            }
        };
    


   const handleShowDelete = (item) => {
    setSelectDoor(item);
    setShowDelete(true);
  }

    const filteredHostelRoom = rooms.filter(cls => {
  const term = searchFilter.toLowerCase();
  return (
    cls.dormitory_name.toLowerCase().includes(term) ||
    cls.type.toLowerCase().includes(term) ||
    cls.room_type.toLowerCase().includes(term) ||
    cls.room_no.toLowerCase().includes(term)
  );
});



    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='Hostel' message2='Hostel Rooms' />
                      {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
                            <div className="profile-card">
                                <p className="profile-heading">Add Hostel Rooms</p>
                                <form className='mt-4' onSubmit={handleSubmit}>
                                        {/* Dormitory */}
                                        <div className='profile-input-area mb-4'>
                                            <label className='profile-badge'>Dormitory*</label>

<select
  name='dormitory'
  className='profile-input'
  value={formData.dormitory}
  onChange={handleChange}
  required
>
  <option value=''>Select Dormitory...</option>
  {dormitory.map((d, index) => (
    <option key={index} value={d.id}>
      {d.dormitory_name}
    </option>
  ))}
</select>


                                        </div>
                                        {/* Room Number */}
                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Room Number*</label>
                                            <input
                                                type="number"
                                                name="room_no"
                                                className="profile-input"
                                                value={formData.room_no}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* Type */}
                                        <div className='profile-input-area mb-4'>
                                            <label className='profile-badge'>Room Type *</label>

                                         
                                            <select name='room_type' value={formData.room_type} onChange={(e) => {
                                                if (e.target.value === 'add_new') {
                                                    handleAddNewRoomType();
                                                } else {
                                                    handleChange(e);
                                                }
                                            }} className='profile-input' required>
                                                <option value=''>--- Select ---</option>
                                                {roomList.map((cat, index) => (
                                                    <option key={index} value={cat}>{cat}</option>
                                                ))}
                                                <option value='add_new'>+ Add New Room Type</option>
                                            </select>

                                        </div>
                                        {/* Number Of Bed */}
                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Number Of Bed*</label>
                                            <input
                                                type="number"
                                                name="no_of_bed"
                                                className="profile-input"
                                                value={formData.no_of_bed}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* Cost Per Bed */}
                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Cost Per Bed*</label>
                                            <input
                                                type="number"
                                                name="bed_cost"
                                                className="profile-input"
                                                value={formData.bed_cost}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* Description */}
                                        <div className="profile-input-area mb-4">
                                            <label htmlFor="description" className="profile-badge">
                                                Description
                                            </label>
                                            <textarea id='description' name="description" className="profile-input" placeholder='Enter here...'
                                                value={formData.description}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        {/* Button */}
                                        <div className="text-center">
              <button type="submit" className="profile-btn me-2">
{editId ? <><AiOutlineEdit /> UPDATE</> : <><FaCheck /> SAVE</>}
              </button>       
                            {editId && (
    <button
      type="button"
      className="profile-btn2"
      onClick={() => {
        setFormData({             dormitory_name: '',
            room_no: '',
            room_type: '',
            no_of_bed: '',
            bed_cost: '',
            description: '' });
        setEditId('');
      }}
    >
      Cancel
    </button>
)}

                                        </div>
                                </form>
                            </div>
                        </div>
                        {/* table-section */}
                        <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                            <div className='profile-card'>

                                <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                    <span className="profile-heading align-content-center">Hostel Rooms List</span>

                                    <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                        <input
                                            type='text'
                                            name='search'
                                            className='profile-input border-bottom rounded-0'
                                            placeholder='Search...'
                                            value={searchFilter}
                                            onChange={(e) => setSearchFilter(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <table className='w-100 text-center'>
                                        <thead className='account-thead'>
                                            <tr>
                                                <th className='rounded-start-4'>S No</th>
                                                <th>Dormitory (Type)</th>
                                                <th>Room Number</th>
                                                <th>Room Type</th>
                                                <th>No Of Bed</th>
                                                <th>Cost/ Bed</th>
                                                <th className='rounded-end-4'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredHostelRoom.length > 0 ? (
                                                filteredHostelRoom.map((itm, id) => (
                                                    <tr className='account-tr' key={id}>
                                                        <td>{id + 1}</td>
                                                        <td>{itm.dormitory_name} ({itm.type} Hostel)</td>
                                                        <td>{itm.room_no}</td>
                                                        <td>{itm.room_type}</td>
                                                        <td>{itm.no_of_bed}</td>
                                                        <td>₹ {itm.bed_cost}</td>
                                                        <td>
                                                            <MdOutlineEdit className='account-icon1' title='Edit' onClick={() => handleEdit(itm)} />
                                                            <RiDeleteBin6Line className='account-icon2 ms-2' title='Remove' onClick={() => handleShowDelete(itm)} />
                                                        </td>
                                                    </tr>
                                                ))) :
                                                <tr>
                                                    <td colSpan="5" className="text-center py-3 text-muted">
                                                        No Data found.
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                
                            </div>
                                       
    {showDelete && (
        <>
          <section className='ins-dialog'>
            <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

              <p className='ins-dialog-heading text-danger'>Remove This Room from Hostel</p>

              <div className='table-responsive'>
                <table className='w-100'>

                  <thead className='account-thead'>
                                                                    <th className='rounded-start-4'>Dormitory (Type)</th>
                                                <th>Room Number</th>
                                                <th>Room Type</th>
                                                <th>No Of Bed</th>
                                                <th>Cost/ Bed</th>
                                                <th className='rounded-end-4'>Description</th>
                  
                  </thead>

                  <tr className='account-tr'>
                                                        <td>{selectedDoor.dormitory_name} ({selectedDoor.type} Hostel)</td>
                                                        <td>{selectedDoor.room_no}</td>
                                                        <td>{selectedDoor.room_type}</td>
                                                        <td>{selectedDoor.no_of_bed}</td>
                                                        <td>₹ {selectedDoor.bed_cost}</td>
                                                        <td>{selectedDoor.description || '--'}</td>
                  </tr>


                </table>
              </div>

              <p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Hostel Room will be permanently removed.</p>

              <button className='profile-btn me-2' onClick={() => handleDelete(selectedDoor.id)}>Remove</button>
              <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


            </div>
          </section>
        </>
      )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DormitoryRoom